import React from 'react';
import { pushGTMEvent } from 'pubweb-smokey/dist/utils/analytics';
import {
  CTAWrapper,
  CTAContent,
  CTAContentInner,
  CTAHeader,
  CTAButton,
  CTABorder,
  CTABackground,
} from './CTA.styled';

const CTA = () => {
  return (
    <CTAWrapper>
      <CTAContent>
        <CTAContentInner>
          <CTAHeader className="cta-header">
            See the finished product.
          </CTAHeader>
          <CTAButton
            className="cta-button"
            href="/find-a-home/"
            onClick={() => {
              pushGTMEvent('ch.cta_click', 'dtr_ift_view_homes', {
                location: 'Interactive Facility Tour',
                category: 'home_search',
                action: 'button',
                label: 'dtr_ift_view_homes',
              });
            }}
          >
            View Homes
          </CTAButton>
        </CTAContentInner>
      </CTAContent>
      <CTABorder />
      <CTABackground />
    </CTAWrapper>
  );
};

export default CTA;
